import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1120px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          漫画分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          按分类浏览，快速找到你想看的漫画类型
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#"
              className="flex flex-col items-center gap-2 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <span className="font-heading text-sm text-foreground-800 whitespace-nowrap">
                {item.title}
              </span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}